
const OnboardingActions = {
  ONBOARDING_PROFILE_STEP: 'ONBOARDING_PROFILE_STEP',
  RESET_STEP: 'RESET_STEP',
  UPDATE_PROGRESS: 'UPDATE_PROGRESS',
  SET_CURRENT_COMPLETED_STEP: 'SET_CURRENT_COMPLETED_STEP',
  SET_JOBS_LOADING: "SET_JOBS_LOADING",
  FETCH_JOBS_REMAINING: 'FETCH_JOBS_REMAINING',
  SET_FORECASTED_JOBS: 'SET_FORECASTED_JOBS'
};

export default OnboardingActions;
